import { useMemo } from 'react';
import { useAuth } from '../utils/AuthContext';
import { ROLES_CAN_DELETE } from '../config/tenantRoles';

export const useCanDelete = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const rol = String(user?.rol || '').toLowerCase();
    return ROLES_CAN_DELETE.includes(rol);
  }, [user?.rol]);
};

export default useCanDelete;
